import { css } from '@emotion/react';
import UnderlineSvg from '../../../assets/svg/wordDecorations/underlines/sharpie-stroke-bold.svg';
import UnderlineSimpleSvg from '../../../assets/svg/wordDecorations/underlines/underline-08.svg';
import UnderlineSvg_10 from '../../../assets/svg/wordDecorations/underlines/underline-10.svg';
import UnderlineSvg_11 from '../../../assets/svg/wordDecorations/underlines/underline-11.svg';
import UnderlineSvg_17 from '../../../assets/svg/wordDecorations/underlines/underline-17.svg';
import { colors } from '../../../utils/styleguide';

export const variants = {
  multipleUnderlines: {
    imgComponent: UnderlineSvg,
    innerCSS: css`
      width: 100%;
      position: absolute;
      left: 50%;
      bottom: -30%;
      height: 30%;
      transform: translate(-50%, 0);
    `,
  },
  underline: {
    imgComponent: UnderlineSimpleSvg,
    innerCSS: css`
      width: 110%;
      position: absolute;
      left: 50%;
      bottom: -15%;
      height: 15%;
      transform: translate(-50%, 0);
    `,
  },
  underline10: {
    imgComponent: UnderlineSvg_10,
    innerCSS: css`
      width: 100%;
      height: 9px;
      position: absolute;
      left: 50%;
      bottom: -20%;
      height: 25%;
      transform: translate(-50%, 0);
    `,
  },
  underline11: {
    imgComponent: UnderlineSvg_11,
    innerCSS: css`
      width: 100%;
      height: 8px;
      position: absolute;
      left: 50%;
      bottom: -20%;
      height: 25%;
      transform: translate(-50%, 0);
    `,
  },
  underline17: {
    imgComponent: UnderlineSvg_17,
    innerCSS: css`
      width: 100%;
      height: 11px;
      position: absolute;
      left: 50%;
      bottom: -35%;
      height: 35%;
      transform: translate(-50%, 0);
    `,
  },
};

export type UnderlineVariants = keyof typeof variants;

type Props = {
  children?: React.ReactNode;
  variant?: UnderlineVariants;
  className?: string;
  color?: string;
};

const SharpieUnderlineWord = ({
  children,
  variant = 'multipleUnderlines',
  className,
  color = colors.black,
}: Props) => {
  const variantData = variants[variant] || {};
  const UnderlineComponent = variantData.imgComponent;
  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      {children}
      <UnderlineComponent
        css={css`
          ${variantData.innerCSS}
          > * {
            fill: ${color};
          }
        `}
        className={className}
        preserveAspectRatio="none"
      />
    </span>
  );
};

export default SharpieUnderlineWord;
